<template lang="pug">
  .container
    .row
      .col-12
        h1 FedEx Connection Tutorial
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 1
          .card-body
            .step1
              p Sign up for an account with FedEx. Or login if you're already registered. 
                a( target="blank" href="https://www.fedex.com/fcl/web/jsp/contactInfo1.jsp?appName=oadr&locale=us_en") (https://www.fedex.com/fcl/web/jsp/contactInfo1.jsp?appName=oadr&locale=us_en)
              img(src="@/assets/img/tutorials/fedex1.png")
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 2
          .card-body
            .step2
              p Your Account Number should be displayed on your profile page. 
                a( target="blank" href="https://www.fedex.com/myprofile/accountmanagement/?locale=en_US") (https://www.fedex.com/myprofile/accountmanagement/?locale=en_US)
              .col-8.offset-2
                img(src="@/assets/img/tutorials/fedex2.png")
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 3
          .card-body
            .step3
              p To obtain your Meter Number, log into the FedEx Developer Center. You might see a Terms & Conditions screen. Check both boxes and click "I Accept". 
                a( target="blank" href="https://www.fedex.com/us/developer/web-services/process.html?tab=tab4") (https://www.fedex.com/us/developer/web-services/process.html?tab=tab4)
              img(src="@/assets/img/tutorials/fedex3.png")
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 4
          .card-body
            .step4
              p   Click on the "Get Production Key" button on this page: 
                a(target="blank" href="https://www.fedex.com/us/developer/web-services/process.html?tab=tab4") https://www.fedex.com/us/developer/web-services/process.html?tab=tab4.
              .col-8.offset-2
                img(src="@/assets/img/tutorials/fedex4.png")
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 5
          .card-body
            .step5
              p You will need to fill out the FedEx registration form before you can get your FedEx Meter Number. Below is the set of answers you will most likely be using:
              p Do you intend to resell your software? No
              p Please check the box next to each type of FedEx web services you intend to use in your integration solution: Select the "FedEx Web Services for Shipping (includes Rate, Track, etc.)" option.
              p Please indicate whether you are developing your FedEx integration solution as a Corporate Developer or as a Consultant. Corporate Developer
              .col-8.offset-2
                img(src="@/assets/img/tutorials/fedex5.png")
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 6
          .card-body
            .step6
              p Accept the license agreement.
              .col-8.offset-2
                img(src="@/assets/img/tutorials/fedex6.png")
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 7
          .card-body
            .step7
              p Fill in your contact information. (some fields may be prefilled already with your profile information)
              .col-8.offset-2
                img(src="@/assets/img/tutorials/fedex7.png")
        .carrier.card.shadow.mb-4
          .card-header.py-3
            h3.text-center.m-0.font-weight-bold.text-primary() Step 8
          .card-body
            .step8
              p Continue through the Developer Info page, and then get your Meter Number on the 5th and final step.
              .col-8.offset-2
                img(src="@/assets/img/tutorials/fedex8.png")



</template>

<script>
export default {
  name: 'FedexConnection',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
img{
  width:100%;
}
.container{margin-top:50px;}

</style>
